// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Yu_LZ","delete":"styles_delete__2a_UP","update":"styles_update__sDIDP","add":"styles_add__Qh4LI"};